<template>
  <div>
    <v-text-field
      v-if="isEmpty(generatedRouteNames)"
      v-bind:value="value"
      v-on:input="updateValue($event)"
      :error-messages="errorMessages"
      :placeholder="$t('route_name')"/>
    <v-autocomplete
      v-else
      auto-select-first
      v-bind:value="value"
      v-on:input="updateValue($event)"
      :items="generatedRouteNames"
      :error-messages="errorMessages"
      :label="$tc('route_name')"
      :placeholder="$t('select_route')"
      prepend-inner-icon="mdi-truck"/>
  </div>
</template>

<script>
import { isEmpty, split, map, trim, each } from 'lodash'

export default {
  name: 'RouteNamePicker',
  props: {
    value: String,
    routeNameRules: String,
    errorMessages: Array
  },
  methods: {
    /**
     * Trigger an update event when the form input has changed
     * @param value
     */
    updateValue (value) {
      this.$emit('input', value)
    },
    isEmpty: isEmpty
  },
  computed: {
    /**
     * Generate the route names according the route name rules string.
     */
    generatedRouteNames () {
      if (isEmpty(this.routeNameRules)) {
        return []
      }
      const routeNameEntries = map(split(this.routeNameRules, '\n'), trim)
      // For each element in the array try to parse it as a range (delimited by a dash) or treat it as a scalar and add
      // it alone to the list of routeNames.
      const result = []
      each(routeNameEntries, entry => {
        const parts = map(split(entry, '-'), trim)
        // Parse string padded ranges (e.g. RT001-RT099 and AM100R-AM2000R) to an array of possible values.
        if (parts.length === 2) {
          const rangeParts = parts[0].match(/^([^0-9]*)(\d*)(.*)$/)
          const prepend = rangeParts[1]
          const append = rangeParts[3]
          const rangeNumericStart = Number.parseInt(rangeParts[2])
          const rangeNumericEnd = Number.parseInt(parts[1].match(/^([^0-9]*)(\d*)(.*)$/)[2])

          for (let i = rangeNumericStart; i <= rangeNumericEnd; i++) {
            result.push(`${prepend}${i.toString()}${append}`)
          }
        } else {
          result.push(entry)
        }
      })
      return result
    }
  }
}
</script>

<style scoped>

</style>
